import React from 'react';
import '../styles/PreguntasSeguridad.scss';
import PreguntaComponent from './PreguntaComponent';
import appStore from '../stores/AppStore.js';
import { observer } from 'mobx-react';
import { FormControl, Button, LinearProgress, Typography, IconButton } from '@material-ui/core';
import AutorizacionComponent from './AutorizacionComponent';
import PopUpErrorPreviRed from './utils/PopUpErrorPreviREd';
import ViewConstants from '../utils/ViewConstants';
import { KeyboardBackspaceOutlined } from '@material-ui/icons';
import popup from '../stores/PopupStore';

const component = observer(
  class PreguntasSeguridadComponent extends React.Component {
    state = {
      verMensaje: false,
      btnInactivo: true,
      pregOk: false,
      respuestas: [],
      preguntas: [],
    };

    componentDidMount = () => {
      this.cargarPreguntas();
    };

    handleChange = (pregunta, seleccion) => {
      this.state.preguntas.forEach((preg) => {
        if (preg.codigo === pregunta.codigo) {
          preg.respuestaSeleccionada = seleccion;
          this.setState((prevState) => ({
            btnInactivo: false,
            verMensaje: false,
            pregOk: true,
            preguntas: prevState.preguntas,
          }));
        }
      });
      this.verificaPreguntas();
    };

    onBtnEnviar = () => {
      appStore.generateDataLayer({ eventAction: 'step_2', eventLabel: 'identidad_siguiente' });
      if (this.state.pregOk) {
        this.setState({
          verMensaje: false,
        });
        let respuestas = [];
        this.state.preguntas.forEach((pregunta) => {
          if (pregunta.respuestaSeleccionada) {
            respuestas.push({ codigopregunta: pregunta.codigo, codigorespuesta: pregunta.respuestaSeleccionada });
          }
        });
        appStore.preguntaSeguridadStore.validarRespuestas(appStore.rutCliente, respuestas, this.onRespuestasValidas);
      } else {
        this.setState({
          verMensaje: true,
        });
      }
    };

    onRespuestasValidas = () => {
      appStore.cargarSolicitudesCliente(this.onResultSolicitudes);
      //appStore.changeNavigation(ViewConstants.ETAPA_SELECCION_BANCO);
    };

    onResultSolicitudes = () => {
      appStore.cargarMonedas();
      if (appStore.solicitudesCliente && appStore.solicitudesCliente.length > 0) {
        appStore.changeNavigation(ViewConstants.ETAPA_LISTADO_SOLICITUDES);
      } else {
        appStore.changeNavigation(ViewConstants.ETAPA_SELECCION_BANCO);
      }
    };

    verificaPreguntas = () => {
      this.state.preguntas.forEach((pregunta) => {
        if (pregunta.respuestaSeleccionada === undefined) {
          this.setState({
            pregOk: false,
          });
        }
      })
      return this.state.pregOk;
    };

    noPreguntas = () => {
      popup.setPopupData({
        message:
          'en estos momentos no podemos atenderte, por favor acércate a cualquiera de nuestros centros de servicio ubicados en tiendas ripley o sucursales banco ripley para completar el proceso',

        btns: [{ label: 'aceptar', close: true, full: true, css: 'btn-morado' }],
      });
      popup.showPopup();
    };

    previredAutorizado = () => {
      this.cargarPreguntas();
    };

    previredRechazado = () => {
      this.cargarPreguntas();
    };

    cargarPreguntas = () => {
      this.setState({ preguntas: [] });
      appStore.preguntaSeguridadStore.obtenerPreguntas(appStore.rutCliente, appStore.numSerie, this.onPreguntasOk);
    };

    onPreguntasOk = (preguntas) => {
      this.setState({ preguntas: preguntas });
    };

    onVolver = () => {
      appStore.changeNavigation(ViewConstants.ETAPA_DATOSCLIENTE);
    };

    onReintentar = () => {
      this.cargarPreguntas();
    };

    render() {
      return (
        <div className="contenedorPrincipal">
          <div className="paso">
            <div>
              <Typography className="tituloBR">
                <IconButton onClick={this.onVolver}>
                  <KeyboardBackspaceOutlined />
                </IconButton>
                Confirmaremos tu identidad
              </Typography>
            </div>
          </div>
          <LinearProgress variant="determinate" color="secondary" value={appStore.navigationSection * (100 / ViewConstants.TOTAL_ETAPAS)} className="barraProgreso" />
          <div>
            <FormControl component="fieldset" className="grupoPregunta" id="frmPreguntas">
              <div className="contenedorPregunta">
                {this.state.preguntas.map((pregunta) => (
                  <PreguntaComponent key={pregunta.codigo} pregunta={pregunta} handleChange={this.handleChange} />
                ))}
              </div>
            </FormControl>
          </div>
          {!this.state.verMensaje ? <p className="textoError" /> : <p className="textoError">Debe seleccionar una respuesta para cada pregunta</p>}

          <div className="grupoBotones">
            {}
            <Button id="btnEnviar" variant="contained" className="botonMoradoOscuro" color="primary" fullWidth={true} disabled={this.state.btnInactivo} onClick={this.onBtnEnviar}>
              siguiente
            </Button>
          </div>
          <AutorizacionComponent onAutorizar={this.previredAutorizado} onRechazar={this.previredRechazado} />
          <PopUpErrorPreviRed onVolver={this.onVolver} onReintentar={this.onReintentar} />
        </div>
      );
    }
  }
);

export default component;
